module.exports = __webpack_public_path__ + "assets/img/bg.ba43cf82.png";